import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  svgContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none"
  }
}))
